import { ResultSet } from "@cubejs-client/core";
import { QueryProps } from "./use-query";

enum QUERY_STATUS {
  READY,
  LOADING,
  ERROR,
  SUCCESS,
}

type QueryStatusType = typeof QUERY_STATUS[keyof typeof QUERY_STATUS];
interface GenericQueryStatus<T extends QueryStatusType> {
  type: T;
  queryProps: QueryProps;
  errorMessage: string;
  result: ResultSet<any>;
}

type QueryReadyStatus = Pick<GenericQueryStatus<QUERY_STATUS.READY>, 'type'>;
type QueryLoadingStatus = Pick<GenericQueryStatus<QUERY_STATUS.LOADING>, 'type' | 'queryProps'>;
type QueryErrorStatus = Pick<GenericQueryStatus<QUERY_STATUS.ERROR>, 'type' | 'queryProps' | 'errorMessage'>;
type QuerySuccessStatus = Pick<GenericQueryStatus<QUERY_STATUS.SUCCESS>, 'type' | 'queryProps' | 'result'>;

export type QueryStatus = QueryReadyStatus | QueryLoadingStatus | QueryErrorStatus | QuerySuccessStatus;
export { QUERY_STATUS };